import React from "react"
// nodejs library that concatenates classes
import classNames from "classnames"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import { privaseeBlue } from "assets/jss/material-kit-react.jsx"

import { Link } from 'gatsby'



// @material-ui/icons

// React icons
import { FaPlay } from "react-icons/fa"

// core components
import Header from "components/Header/Header.jsx"
import Footer from "components/Footer/Footer.jsx"
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Button from "components/CustomButtons/Button.jsx"
import HeaderLinks from "components/Header/HeaderLinks.jsx"
import Parallax from "components/Parallax/Parallax.jsx"
import Wrapper from "components/Wrapper/Wrapper.js"

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx"

// Sections for this page
import ProductSection from "./Sections/ProductSection.jsx"
import TeamSection from "./Sections/TeamSection.jsx"
import WorkSection from "./Sections/WorkSection.jsx"
import HowItWorksSection from "./Sections/HowItWorksSection.jsx"

const path = require("path")

const dashboardRoutes = []

class LandingPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props
    console.log({ ...rest })
    return (
      <>

        <Wrapper>
          <Parallax
            filter
            image={require("assets/img/website-spa-march-2020.png")}
            style={{ backgroundColor: "#005b9a" }}
          >
            <div className={classes.container}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={5}>
                  <h1 className={classes.title}>
                    Don&apos;t let Data Compliance get in the way of your business
                  </h1>
                  <h5>We help you understand what data you have, where it comes from and what you do with it, see how: </h5>
                  <Button color="danger" target="_blank" className={classes.navLink} >


                    <Link
                      to="/demo"


                      style={{ color: 'white' }}
                    >
                      <b>BOOK A DEMO</b>
                    </Link>
                  </Button>


                </GridItem>
              </GridContainer>
            </div>
          </Parallax>

          <div className={classNames(classes.main, classes.mainRaised)}>
            <div className={classes.container}>
              <ProductSection />
            </div>
            {/*<div
              style={{
                backgroundColor: privaseeBlue,
              }}
            >
              <div className={classes.container}>
                <HowItWorksSection />
              </div>
            </div>*/}
            <div className={classes.container}>
              <TeamSection />
            </div>
          </div>
          <WorkSection />
        </Wrapper>
      </>
    )
  }
}

export default withStyles(landingPageStyle)(LandingPage)
